import { Customer } from '@df/session/customer/customer.interfaces';

export namespace Newsletter {
    /**
     * Subscription form data
     */
    export interface ISubscriptionFormData {
        email: string;
        consent: boolean;
        source?: string;
        firstName?: string;
        lastName?: string;
        dob?: string;
    }

    /**
     * Any change request successful response
     */
    export interface IResponse extends Customer.ILoadResponse {}

    /**
     * Newsletter subsbscription request data
     */
    export interface ISubscribeRequest {
        email: string;
        source?: string;
        consent?: boolean;
    }

    /**
     * Unsubscribtion request data
     *
     * It does not seem correct BE-wise
     */
    export type IUnsubscribeRequest = ICustomerUnsubscribeRequest | IEmailUnsubscribeRequest;

    /**
     * Customer unsubscriptions data
     *
     * It does not seem correct BE-wise
     */
    export interface ICustomerUnsubscribeRequest {
        customerId: number;
    }

    /**
     * By email unsubscriptions data
     *
     * It does not seem correct BE-wise
     */
    export interface IEmailUnsubscribeRequest {
        email: string;
    }

    export interface IUpdateRequest extends ISubscribeRequest {
        subscriberProperties: ISubscriberProperties;
    }

    export interface ISubscriberProperties {}
    export interface ISubscriptionEvent {
        callback: (data: ISubscribeRequest) => Promise<Newsletter.IResponse>;
    }

    export const subscriptionRequest = 'newsletterSubscriptionRequest';
}
